/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WorkflowType {
  Adhoc = 'Adhoc',
  Timed = 'Timed',
  Triggered = 'Triggered'
}
